import { render, staticRenderFns } from "./DeparturesPageFlorianopolis.vue?vue&type=template&id=3fe49cd8&scoped=true&"
import script from "./DeparturesPageFlorianopolis.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageFlorianopolis.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageFlorianopolis.vue?vue&type=style&index=0&id=3fe49cd8&prod&lang=scss&scoped=true&"
import style1 from "./DeparturesPageFlorianopolis.vue?vue&type=style&index=1&id=3fe49cd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe49cd8",
  null
  
)

export default component.exports